import { css, CSSObject, SimpleInterpolation } from 'styled-components'

export const DEVICE_MIN_WIDTH_PX = {
    mobile: 0,
    tablet: 375,
    laptop: 768,
    desktop: 1280,
} as const

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const mediaQuery =
    (minWidthPx: number): typeof css =>
    (fragments: CSSObject | TemplateStringsArray, ...interpolations: SimpleInterpolation[]) =>
        css`
            @media (min-width: ${minWidthPx}px) {
                ${css(fragments, ...interpolations)}
            }
        `

export const device = {
    tablet: mediaQuery(DEVICE_MIN_WIDTH_PX.tablet),
    laptop: mediaQuery(DEVICE_MIN_WIDTH_PX.laptop),
    desktop: mediaQuery(DEVICE_MIN_WIDTH_PX.desktop),
}
